import { render, staticRenderFns } from "./MemberPremoney.vue?vue&type=template&id=c51a2508&scoped=true"
import script from "./MemberPremoney.vue?vue&type=script&lang=js"
export * from "./MemberPremoney.vue?vue&type=script&lang=js"
import style0 from "./MemberPremoney.vue?vue&type=style&index=0&id=c51a2508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51a2508",
  null
  
)

export default component.exports